import { render, staticRenderFns } from "./MobileTableItem.vue?vue&type=template&id=17fe4542&scoped=true"
import script from "./MobileTableItem.vue?vue&type=script&lang=js"
export * from "./MobileTableItem.vue?vue&type=script&lang=js"
import style0 from "./MobileTableItem.vue?vue&type=style&index=0&id=17fe4542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fe4542",
  null
  
)

export default component.exports